var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppSection",
    { attrs: { number: _vm.step, title: "Add text" } },
    [
      _c("AppInput", {
        staticClass: "form-group mb-3 pb-2",
        class: { "form-error": _vm.validation.product.title.$error },
        attrs: {
          label: "Title",
          dataTestId: "title",
          maxlength: "50",
          placeholder: "Title Here...",
          required: ""
        },
        model: {
          value: _vm.value.product.title,
          callback: function($$v) {
            _vm.$set(_vm.value.product, "title", $$v)
          },
          expression: "value.product.title"
        }
      }),
      _vm._v(" "),
      ["callout", "preview"].includes(_vm.value.button.layout)
        ? _c(
            "div",
            { staticClass: "layout-callout-preview" },
            [
              _c(
                "div",
                [
                  _c("AppInput", {
                    staticClass: "form-group mb-3 pb-2",
                    attrs: {
                      label: "Subtitle",
                      dataTestId: "subtitle",
                      maxlength: "100",
                      placeholder: "Enter a description for your followers here"
                    },
                    model: {
                      value: _vm.value.button.tagline,
                      callback: function($$v) {
                        _vm.$set(_vm.value.button, "tagline", $$v)
                      },
                      expression: "value.button.tagline"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("AppInput", {
                key: _vm.value.button.layout,
                staticClass: "form-group mb-0",
                class: {
                  "form-error": _vm.validation.button.button_text.$error
                },
                attrs: {
                  label: "Button*",
                  dataTestId: "button-text",
                  maxlength: "30",
                  placeholder: "Button Text Here..."
                },
                model: {
                  value: _vm.value.button.button_text,
                  callback: function($$v) {
                    _vm.$set(_vm.value.button, "button_text", $$v)
                  },
                  expression: "value.button.button_text"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }